import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

const size = {
  small: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.22221 13.3333H3.85184C3.53751 13.3333 3.23605 13.2085 3.01379 12.9862C2.79152 12.7639 2.66666 12.4625 2.66666 12.1481V3.85185C2.66666 3.53752 2.79152 3.23607 3.01379 3.0138C3.23605 2.79154 3.53751 2.66667 3.85184 2.66667H6.22221"
        stroke="black"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3704 10.963L13.3333 8L10.3704 5.03704"
        stroke="black"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M13.3333 8H6.22223" stroke="black" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  default: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.33333 20H5.77778C5.30628 20 4.8541 19.8127 4.5207 19.4793C4.1873 19.1459 4 18.6937 4 18.2222V5.77778C4 5.30628 4.1873 4.8541 4.5207 4.5207C4.8541 4.1873 5.30628 4 5.77778 4H9.33333"
        stroke="black"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5555 16.4444L20 12L15.5555 7.55556"
        stroke="black"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M20 12H9.33334" stroke="black" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  large: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.4445 26.6667H7.70371C7.07505 26.6667 6.47214 26.4169 6.02761 25.9724C5.58308 25.5279 5.33334 24.925 5.33334 24.2963V7.7037C5.33334 7.07504 5.58308 6.47213 6.02761 6.0276C6.47214 5.58307 7.07505 5.33333 7.70371 5.33333H12.4445"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.7408 21.9259L26.6667 16L20.7408 10.0741"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M26.6667 16H12.4445" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
};

function LogoutIcon(props: Omit<SvgIconProps, "fontSize"> & { fontSize?: "large" | "small" }) {
  const item = size[props.fontSize || "default"];

  return (
    <SvgIcon {...props} fontSize={props.fontSize}>
      {item}
    </SvgIcon>
  );
}

export default LogoutIcon;
